import { Component, OnInit } from '@angular/core';
import { LABELS} from './read-aloud.enum';

@Component({
  selector: 'app-read-aloud',
  templateUrl: './read-aloud.component.html',
  styleUrls: ['./read-aloud.component.scss']
})
export class ReadAloudComponent {
  public displayLabels = LABELS;
  forwardDisabled = true as boolean;
  backwardDisabled = true as boolean;

  toolTipData= {reload:{
    toolTipId:'reload',
    toolTipMessage:'Reload'
  },
  backward:{
      toolTipId:'backward',
    toolTipMessage:'Backward button'
  },
  play:{
    toolTipId:'play',
  toolTipMessage:'Play button'
},
pause:{
toolTipMessage:'Pause button'
},
  forward:{
    toolTipId:'forward',
  toolTipMessage:'Forward button'
}};
draggableToolTipData={
  dragDrop:{
    toolTipId:'Drag and drop',
    toolTipMessage:'Drag and drop (mouse-only functionality)'
    },
  close:{
      toolTipId:'close',
    toolTipMessage:'Close'
  }
}
draggableMobileToolTipData={
  dragDrop:{
    toolTipId:'Drag and drop',
    toolTipMessage:'Drag and drop'
    },
  close:{
      toolTipId:'close',
    toolTipMessage:'Close'
  }
}
useCase = 'Read-Aloud with boundrary';
selectedUseCase = 'Read-Aloud with boundrary';
useCases: string[] = [
  'Read-Aloud with boundrary',
  'Read-Aloud without boundrary',
  'Read-Aloud with right side draggable button'
];

  playPause(event: any) {
    let x: any = document.getElementById('audio'); 
    if (event) {
      this.backwardDisabled = false;
      this.forwardDisabled = false;
        x.play();
    } else {
      x.pause();
    }
      // you can add the logic here of PLay pause by event flag
  }

  playerReload() {
      let x: any = document.getElementById('audio'); 
      x.currentTime = 0;
      if(!this.forwardDisabled && !this.backwardDisabled){
        x.play();
      }
      // relaod the player
  }

  closeEvent(){
    let x: any = document.getElementById('audio'); 
    x.pause();
  }
  
  forwardPlay(){
    let x: any = document.getElementById('audio'); 
    x.currentTime = x.currentTime+ 2;
  }

  backwardPlay(){
    let x: any = document.getElementById('audio'); 
    x.currentTime = x.currentTime- 2;
  }
}
